import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss']
})
export class FilePreviewComponent implements OnInit {

  @Input()
  file: File;

  @Output()
  deleteFileEvent = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  deleteFile() {
    this.deleteFileEvent.emit();
  }
}
